export default function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent;
  const iOS = /iPad|iPhone|iPod/.test(ua);
  const iPadOS13up =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  return iOS || iPadOS13up;
}
